export enum LabelPosition {
    Left,
    Right,
}
